import store from '@/store/index.js'

export function money(value) {
  const options = {
    style: "currency",
    currencyDisplay: "symbol",
    currency: store.getters['resort/currency'],
    maximumFractionDigits: 2
  };

  return new Intl.NumberFormat(store.getters['device/locale'], options).format(parseFloat(value));
}
